import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../core/shared/service/crud/mvs-crud-mode.enum';

/**
 * [CW-PERSON-REFACTOR] Generic CRUD service of {@code cw.CwCaseProductPersonRole}
 * ({@code /mvsa/cw/caseProductPersonRoles}) — the LINE-level role occupancy.
 *
 * <h3>What this row decides</h3>
 * It is the truth about roles for its product line, and it is the row per-line cardinality is
 * counted over, grouped by {@code (cwCaseProduct, type)}. Counting the participations
 * ({@code cw.CwCaseProductPerson}) instead would report one human sitting in six lines as six people
 * in a role capped at one.
 *
 * <h3>Reads, not writes</h3>
 * Roles are written server-side by the product person assignment seam, which writes BOTH levels in
 * one transaction — participation with find-or-create on {@code (line, casePerson)}, roles with set
 * semantics — and materializes the coverage and question children hanging off the role. A
 * client-side write here would leave those orphaned.
 */
@Injectable({
    providedIn: 'root',
})
export class CwCaseProductPersonRoleService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cw/caseProductPersonRoles');
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

}
